<template>
  <div class="layout">
	  <Top class="top"   @changeCollapse="changeCollapse" :isCollapse="isCollapse" @changeItem="changeItem"></Top>
     
	<!-- 左侧导航区域 -->
    <MyMenu class="menu" :menu="menu"  :isCollapse="isCollapse" v-if="menuLayout!=1"/>
    <!-- 右侧内容区域 -->	
    <Content class="content" :class="{isActive: isCollapse,isFull:(menuLayout==1)}"  ref="content"/> 		
    
  </div>  
</template>

<script>
import MyMenu from "./Mymenu.vue";
import Top from "./Top.vue";
import Content from "./Content.vue";
import MenuTree from '@/components/MenuTree'
import store from '@/store/index'
export default {
  components: {
    MyMenu,
    Content,
	Top,
	MenuTree,
  },
  data() {
    return {
      isCollapse: store.state.settings.theme.isCollapse==1?true:false,
	  menu:store.state.settings.theme.menuLayout==0?store.state.menuModule.dymenuList:[]
    };
  },
  mounted() {
  },
  computed:{
	  menuLayout(){		  
		return store.state.settings.theme.menuLayout;
	  },
  },
  provide(){//声明一个方法注入到子页面
  	return{
  		reload:this.reload
  	}
  },
  methods: {
    changeCollapse() {	
      this.isCollapse = !this.isCollapse;
	  let theme=JSON.parse(localStorage.getItem('theme'));
	  theme.isCollapse=this.isCollapse?1:0;
	  store.dispatch('settings/changeSetting', theme)	 
    },	
	changeItem(e){
		console.log('父组件接收',e)
		this.menu=e.child||e;
	},
	reload(){
		this.$nextTick(()=>{
			this.$refs.content.reload();//调用子组件中reload方法。这里不直接控制Content组件显示或隐藏实现刷新因为这里刷新会重新打开关闭的tab页面
		})
	}
  },

};
</script>

<style lang='less' scoped>
.layout {
	 height: 100vh;
	  display: flex;
	  flex-direction: column;
  .menu {
    /*width: 200px;
    min-height: 500px;*/
	height: calc(100vh - 60px); /* 高度计算 */
	overflow-y: auto; /* 允许菜单单独滚动 */
    position: fixed;
    top: 60px;
    bottom: 0;
  }
  .top {
       /*position: fixed;  固定定位 */
       top: 0;
       left: 0;
       right: 0;
       height: 60px;
  }
  .content {
	  margin-left: 200px;
        /*height: calc(100vh - 70px);  高度计算 */
        overflow-y: auto; /* 允许内容区域单独滚动 */
        transition: all 0.3s;
  }
  .isActive {
    margin-left: 64px;
  }
  .isFull{
	  margin-left: 0px;
  }
  .isDown{
  	  top: 95px;
  }
  /* 响应式调整 - 小屏幕时菜单折叠状态 */
    @media screen and (max-width: 992px) {
      .menu {
        width: 64px;
      }
      .content {
        margin-left: 64px;
      }
    }
}
</style>